<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner :animation-duration="2000" :size="80" color="#63c2de" class="offset-6"></semipolar-spinner>
        </div>
        <table-business
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-boxes mr-2'></i>Cuentas Business</h4>"
          v-else
        ></table-business>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TableBusiness from "./TableBusiness";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

import ModalCreatePartner from "../notifications/ModalCreatePartner";

import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";

export default {
  name: "promotions",
  components: {
    TableBusiness,
    SemipolarSpinner,
    ModalCreatePartner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "provider", label: "Provedor de Marketing", sortable: true },
        { key: "api_version", label: "Facebook API Version", sortable: true },
        { key: "user_id", label: "ID de usuario", sortable: true },
        {key:"acciones",label:"Acciones"}
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getBusiness();
  },
  methods: {
    getBusiness() {
      var business = store.getters.getBusiness;
      if (business.length == 0) {
        this.isLoading = true;
        store.dispatch("getBusiness").then(() => {
          business = store.getters.getBusiness;
          shuffleArray([business]);
          this.isLoading = false;
          this.items = business;
          this.itemsArray = business;
        });
      } else {
        shuffleArray([business]);
        this.items = business;
        this.itemsArray = business;
      }
    }
  }
};
</script>
